<template>
  <div>
    <div class="field-title">{{initData.title}}</div>
    <div class="date-picker">
      <div class="picker-item" v-if="initData.noTimeslot">
        <div class="date-box">
          <span>无需选择预订时间</span>
        </div>
      </div>
      <template v-else>
        <div class="picker-item" @click="startPickerShow = true">
          <div class="date-box">
            <span>{{shipDateColumns[shipDateChoosed]}}</span>
            <van-icon class="icon" name="arrow-down" />
          </div>
        </div>
        
        <div v-if="showTimeSlot" class="picker-item" @click="endPickerShow = true">
          <div class="date-box">
            <span>{{timeSlotColumns[timeSlotChoosed]}}</span>
            <van-icon class="icon" name="arrow-down" />
          </div>
        </div>
      </template>
    </div>
    <!-- 开始时间 -->
    <base-picker :columns="shipDateColumns" :initIndex="shipDateChoosed" :visible.sync="startPickerShow" @update:value="shipDateChange" />
    <!-- 结束时间 -->
    <base-picker :columns="timeSlotColumns" :initIndex="timeSlotChoosed" :visible.sync="endPickerShow" @update:value="timeSlotChange" />
  </div>
</template>

<script>
import BasePicker from '@/components/BasePicker'

export default {
  name: 'BookingDatePicker',

  components: {
    BasePicker
  },

  props: {
    initData: Object,
    initChoosed: Object
  },

  data () {
    return {
      startPickerShow: false,
      shipDateChoosed: 0,
      endPickerShow: false,
      timeSlotChoosed: 0
    }
  },

  computed: {
    shipDateColumns () {
      return this.initData.shipDates.map(x => x.shipDate)
    },
    timeSlotColumns () {
      return this.initData.shipDates[this.shipDateChoosed].timeSlotList.map(x => `${x.timeslotStart}-${x.timeslotEnd}`)
    },
    showTimeSlot() {
      return  +this.initData.shipDates[this.shipDateChoosed].timeSlotList[this.timeSlotChoosed].timeslot!==-1
    }

  },

  watch: {
    initChoosed: {
      deep: true,
      handler (newVal) {
        if (newVal) {
          const shipDateChoosed = this.initData.shipDates.findIndex(x => x.shipDate === this.initChoosed.shipDate)
          this.shipDateChoosed = shipDateChoosed
          this.timeSlotChoosed = this.initData.shipDates[this.shipDateChoosed].timeSlotList.findIndex(x => x.timeslot === this.initChoosed.timeslot)
        }
      },
      immediate: true
    }
  },

  methods: {
    shipDateChange ({ index }) {
      const currentSlot = this.initData.shipDates[index].timeSlotList[0]
      this.shipDateChoosed = index
      this.timeSlotChoosed = 0
      this.emitChange(currentSlot)
    },
    timeSlotChange ({ index }) {
      const currentSlot = this.initData.shipDates[this.shipDateChoosed].timeSlotList[index]
      this.timeSlotChoosed = index
      this.emitChange(currentSlot)
    },
    emitChange (currentSlot) {
      this.$emit('stockChange', {
        index: this.initData.index,
        stock: currentSlot.currentInv,
        shipDate: currentSlot.shipDate,
        timeslot: currentSlot.timeslot
      })
    }
  }
}
</script>

<style lang="less" scoped>
.date-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .picker-item {
    width: 280px;
    padding-top: 6px;
    border-bottom: 1Px solid #eaeaea;
    .date-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 34px;
      padding-bottom: 12px;
      font-size: 24px;
      color: #999;
      .icon {
        font-size: 20px;
        color: #333;
      }
    }
  }
}
</style>
